import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

// The web config keys are NOT secret — they are public identifiers.
// Security is enforced by Firestore rules, not by hiding these values.
// Values come from `frontend/.env` (see .env.example). In CRA, only vars
// prefixed with REACT_APP_ are exposed to the bundle.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Firebase is OPT-IN: it only initializes when the REACT_APP_FIREBASE_*
// values are actually present AND the build isn't on the supabase plane.
// Stamped/self-hosted instances ship no Firebase config at all (auth is
// GoTrue, data is Postgres — data/supabaseClient.js + authPlane.js), and
// firebase.auth() THROWS on an empty apiKey, so an unconfigured build must
// never touch the SDK. Every consumer already branches on isPg() / null
// before using these exports.
const IS_PG =
  (typeof window !== 'undefined' && window.__KIT_ENV__?.DATA_PLANE === 'supabase') ||
  process.env.REACT_APP_DATA_PLANE === 'supabase';
const FIREBASE_ENABLED = !IS_PG && !!(firebaseConfig.apiKey && firebaseConfig.projectId);

if (!IS_PG && !FIREBASE_ENABLED) {
  // Don't crash the dev server before a plane is wired up — just warn loudly.
  // eslint-disable-next-line no-console
  console.warn(
    '[firebaseConfig] No data plane configured. Either fill in the ' +
      'REACT_APP_FIREBASE_* values (frontend/.env) or build with ' +
      'REACT_APP_DATA_PLANE=supabase for the self-hosted plane.'
  );
}

if (FIREBASE_ENABLED && !firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const auth = FIREBASE_ENABLED ? firebase.auth() : null;
export const db = FIREBASE_ENABLED ? firebase.firestore() : null;
export default firebase;
